import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPackageBoxOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.142 3.22 12.062 6.225a1 1 0 0 1 .012 1.772l-4.502 2.401a2 2 0 0 1-1.858.013L2.796 7.404a1 1 0 0 1-.011-1.772L7.286 3.23a2 2 0 0 1 1.856-.011"
      clipRule="evenodd"
    />
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.859 3.22 2.797 9.445a1 1 0 0 0-.012 1.772l4.501 2.401c.58.31 1.275.314 1.86.013l12.058-6.227a1 1 0 0 0 .012-1.772L16.714 3.23a2 2 0 0 0-1.855-.011"
      clipRule="evenodd"
    />
    <path
      stroke="#90A4AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.108 12.34v3.939a2 2 0 0 1-1.06 1.765l-5.101 2.724a2 2 0 0 1-1.883 0l-5.102-2.724a2 2 0 0 1-1.06-1.765V12.34M12 21.004v-8.85"
    />
  </svg>
);
export default SvgPackageBoxOpen;
